// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  margin-right: 0.5rem;
}

.div1 {
  padding: 0.625rem;
  text-align: center;
  border-top: 1px solid lightgrey;
}

.p-bold {
  font-weight: bold;
  padding: 0.3125rem 0;
  margin: 0;
}

.p-normal {
  padding: 0.3125rem 0;
  margin: 0;
}

.mt-20 {
  margin-top: 1.25rem;
}

ion-button {
  --border-radius: 0;
}

.coupon-container .coupon-top-section {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}
.coupon-container .coupon-top-section .coupon-heading-class {
  font-weight: 700;
  font-size: 2.625rem;
  line-height: 100%;
  color: var(--ion-black-primary);
  padding: 1.75rem 0 1.5625rem 0;
}

.coupon-field-div {
  width: 49.2%;
}

.coupon-field {
  display: flex;
  place-content: space-between;
  margin-bottom: 20px;
}

.back-btn {
  width: 100px;
  height: 46px;
  background: #0081ca;
  font: normal normal bold 15px/20px Noto Sans;
  letter-spacing: 0px;
  color: #FFFFFF;
  text-transform: uppercase;
}

.back-btn-ltr {
  float: right;
}

.back-btn-rtl {
  float: left;
}

.add-discount-container .listing-header {
  display: flex;
  align-items: center;
  padding: 0.0625rem 0 1.875rem 0;
}
.add-discount-container .listing-header .title-div {
  font: normal normal bold 42px/42px Noto Sans;
  color: var(--ion-color-primary-black);
  text-transform: capitalize;
}

.justify-end {
  justify-content: flex-end;
}

.justify-start {
  justify-content: flex-start;
}

.add-discount-container {
  overflow: auto;
  padding: 1.5rem 1.875rem 1.5rem 1.875rem;
}
.add-discount-container .heading-label {
  font: normal normal bold 1.125rem/27px Noto Sans;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}
.add-discount-container .form-container .form-inputs {
  padding-bottom: 0.75rem;
}
.add-discount-container .form-container .form-inputs ion-item .country-code {
  display: none;
}
.add-discount-container .form-container .form-inputs ion-item.item-has-value .country-code,
.add-discount-container .form-container .form-inputs ion-item.item-has-focus .country-code {
  display: flex;
}
.add-discount-container .form-container .form-inputs ion-label {
  letter-spacing: 0 !important;
  color: var(--ion-color-secondary-black) !important;
  text-transform: uppercase !important;
  opacity: 1 !important;
  font-size: 0.75rem !important;
}

ion-select {
  width: 100%;
  font: normal normal 600 1rem/24px Noto Sans;
}

.company-address-div {
  width: 49.2%;
}

.company-address-class {
  display: flex;
  place-content: space-between;
}

ion-input,
ion-item {
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
  font-size: 1rem;
  line-height: 1.3125rem;
}

ion-list {
  padding: 0;
}

.text-left {
  right: 0 !important;
  left: unset !important;
}

.text-right {
  left: 0 !important;
  right: unset !important;
}

ion-select.LTR::part(icon) {
  opacity: 1;
  color: transparent;
  margin-left: 1rem;
  background: url('down-arrow-dark.1fb8e5fc34077de6.svg') no-repeat center;
}

ion-select.RTL::part(icon) {
  opacity: 1;
  color: transparent;
  margin-right: 1rem;
  background: url('down-arrow-dark.1fb8e5fc34077de6.svg') no-repeat center;
}

.arabic-label {
  direction: ltr !important;
  text-align: right !important;
}

.arabic-select::part(placeholder) {
  direction: ltr;
  text-align: right;
}

.date-div {
  align-items: center;
}

.add-discount-div .listing-header {
  display: flex;
  justify-content: space-between;
  padding: 0.3125rem 0 1.5625rem 0;
}
.add-discount-div .listing-header .title-div {
  font: normal normal bold 1.75rem/28px Noto Sans;
  color: var(--ion-color-primary-black);
  text-transform: capitalize;
}
.add-discount-div .listing-table {
  padding: 0 0 1.25rem;
  overflow-x: auto;
}
.add-discount-div .listing-table .table {
  width: 100%;
}
.add-discount-div .listing-table .table .column-heading {
  font-weight: 500;
  font-size: 0.975rem;
  line-height: 0.875rem;
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
  padding: 0.75rem 0.5625rem 0.75rem 0;
}
.add-discount-div .listing-table .table .checkbox-col {
  width: 40px;
}
.add-discount-div .listing-table .table .img-col {
  width: 90px;
}
.add-discount-div .listing-table .table .ship-to-col {
  min-width: 100px;
  max-width: 244px;
}
.add-discount-div .listing-table .table .product-id {
  font: normal normal bold 1rem/24px Noto Sans;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}
.add-discount-div .listing-table .table .table-body {
  font: normal normal normal 1rem/21px Noto Sans;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}
.add-discount-div .listing-table .table .table-body .table-row {
  border-bottom: 1px solid var(--ion-color-primary-border);
}
.add-discount-div .listing-table .table .table-body .table-row td {
  padding: 0.4375rem 0.5625rem 0.1875rem 0;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.375rem;
  color: var(--ion-color-primary-black);
}
.add-discount-div .listing-table .table .table-body .table-row td .product-image {
  width: 5rem;
  height: 5rem;
  max-width: 5rem;
  max-height: 5rem;
}
.add-discount-div .listing-table .table .table-body .table-row td .product-image img {
  height: 100%;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
}
.add-discount-div .listing-table .table .table-body .table-row .right-arrow {
  display: flex;
  align-items: center;
}

.justify-end {
  justify-content: flex-end;
}

.justify-start {
  justify-content: flex-start;
}

.id-col {
  width: 60px;
}

.name-col {
  width: 135px;
}

.subclass-col {
  width: 100px;
}

.qty-sold-col {
  min-width: 80px;
}

.price-col {
  min-width: 60px;
}

.sku-col {
  min-width: 100px;
}

.uploaded-time-col {
  min-width: 120px;
}

.edit-col {
  min-width: 60px;
}

.edit-img-icon {
  cursor: pointer;
}

.search-icon {
  align-self: center;
  margin: 0.25rem 2.625rem 0 0;
  cursor: pointer;
}

.product-checkbox {
  --opacity: 1;
  --border-color: var(--ion-color-primary-border);
  --border-width: 1px;
}

.thead {
  border-bottom: 1px solid var(--ion-color-primary-border);
  font: normal normal bold 0.75rem/14px Noto Sans;
  letter-spacing: 0;
  color: var(--ion-color-secondary-black);
  text-transform: uppercase;
  opacity: 1;
}

th {
  padding: 0.9375rem 0 1.25rem 0;
}

ion-select::part(icon) {
  opacity: 1;
  margin-left: 1rem;
  color: transparent;
  background: url('down-arrow-dark.1fb8e5fc34077de6.svg') no-repeat center;
}

.add-discount-div {
  padding: 0 0.3125rem 0 0;
}

.profile-bottom-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.profile-bottom-container .cancel {
  font-weight: 400;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
  padding: 0.8125rem 2.1875rem 0.8125rem 2.1875rem;
  cursor: pointer;
}
.profile-bottom-container .cancel:hover {
  font-weight: 600;
}
.profile-bottom-container .profile-button {
  position: relative;
}
.profile-bottom-container .profile-button ion-button {
  --background: var(--ion-color-primary);
  width: 130px;
  height: 46px;
  font-weight: 600;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: 0.4px;
  --box-shadow: none;
  --border-radius: 0;
}

.close-div {
  position: absolute;
  right: 0.3125rem;
  top: 0.3125rem;
}

::-webkit-scrollbar {
  width: 0.625rem;
}

.close-icon {
  cursor: pointer;
}

p.file-name {
  margin: 0;
  margin-top: 0.5rem;
  font-weight: 500;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box !important;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.country-code {
  display: none;
}

.hidden-input {
  visibility: hidden;
}

.file-input {
  opacity: 0;
  display: none;
}

ion-item {
  height: 50px;
}

ng-select {
  height: 50px !important;
}

.upload-btn,
.remove-btn {
  margin-top: auto;
  margin-bottom: auto;
  --background: var(--ion-color-primary);
  font-weight: 600;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: 0.4px;
  height: 38px;
  width: 90px;
  --border-radius: 0;
  --box-shadow: none;
}

remove-btn {
  --background: var(--ion-color-primary-white) !important;
  box-shadow: none;
  color: var(--ion-color-secondary-black);
}

.preview-image {
  height: 100%;
  width: 100%;
  max-width: 116px;
  max-height: 49px;
  object-fit: contain;
  margin: 0.3125rem 0.9375rem 0.3125rem 0 !important;
}

ion-item.item-has-value .country-code,
ion-item.item-has-focus .country-code {
  display: flex;
}

ion-label {
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
}

.spinner-btn {
  color: var(--ion-color-primary-white);
  position: absolute;
  right: 81px;
  top: 0.625rem;
}

.trash-icon {
  cursor: pointer;
}

.arabic-class {
  direction: rtl !important;
}
.arabic-class ion-label {
  -webkit-transform-origin-x: right;
}`, "",{"version":3,"sources":["webpack://./src/app/components/product-discount-details/product-discount-details.component.scss"],"names":[],"mappings":"AAAA;EACC,oBAAA;AACD;;AAEA;EACC,iBAAA;EACA,kBAAA;EACA,+BAAA;AACD;;AAEA;EACC,iBAAA;EACA,oBAAA;EACA,SAAA;AACD;;AAEA;EACC,oBAAA;EACA,SAAA;AACD;;AAEA;EACC,mBAAA;AACD;;AAEA;EACC,kBAAA;AACD;;AAGC;EACC,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AAAF;AAEE;EACC,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,+BAAA;EACA,8BAAA;AAAH;;AAKA;EACC,YAAA;AAFD;;AAKA;EACC,aAAA;EACA,4BAAA;EACA,mBAAA;AAFD;;AAKA;EACC,YAAA;EACA,YAAA;EACA,mBAAA;EACA,4CAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;AAFD;;AAKA;EACC,YAAA;AAFD;;AAKA;EACC,WAAA;AAFD;;AAMC;EACC,aAAA;EACA,mBAAA;EACA,+BAAA;AAHF;AAKE;EACC,4CAAA;EACA,qCAAA;EACA,0BAAA;AAHH;;AAQA;EACC,yBAAA;AALD;;AAQA;EACC,2BAAA;AALD;;AAQA;EACC,cAAA;EACA,wCAAA;AALD;AAOC;EACC,gDAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AALF;AASE;EACC,uBAAA;AAPH;AAUI;EACC,aAAA;AARL;AAcI;;EACC,aAAA;AAXL;AAeG;EACC,4BAAA;EACA,kDAAA;EACA,oCAAA;EACA,qBAAA;EACA,6BAAA;AAbJ;;AAmBA;EACC,WAAA;EACA,2CAAA;AAhBD;;AAmBA;EACC,YAAA;AAhBD;;AAmBA;EACC,aAAA;EACA,4BAAA;AAhBD;;AAmBA;;EAEC,iBAAA;EACA,qCAAA;EACA,UAAA;EACA,eAAA;EACA,sBAAA;AAhBD;;AAmBA;EACC,UAAA;AAhBD;;AAmBA;EACC,mBAAA;EACA,sBAAA;AAhBD;;AAmBA;EACC,kBAAA;EACA,uBAAA;AAhBD;;AAmBA;EACC,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,wEAAA;AAhBD;;AAmBA;EACC,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,wEAAA;AAhBD;;AAmBA;EACC,yBAAA;EACA,4BAAA;AAhBD;;AAmBA;EACC,cAAA;EACA,iBAAA;AAhBD;;AAmBA;EACC,mBAAA;AAhBD;;AAoBC;EACC,aAAA;EACA,8BAAA;EACA,gCAAA;AAjBF;AAmBE;EACC,+CAAA;EACA,qCAAA;EACA,0BAAA;AAjBH;AAqBC;EACC,oBAAA;EACA,gBAAA;AAnBF;AAqBE;EACC,WAAA;AAnBH;AAqBG;EACC,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uCAAA;EACA,oCAAA;AAnBJ;AAsBG;EACC,WAAA;AApBJ;AAuBG;EACC,WAAA;AArBJ;AAwBG;EACC,gBAAA;EACA,gBAAA;AAtBJ;AAyBG;EACC,4CAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AAvBJ;AA0BG;EACC,8CAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AAxBJ;AA0BI;EACC,wDAAA;AAxBL;AA0BK;EACC,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,qCAAA;AAxBN;AA0BM;EACC,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAxBP;AA0BO;EACC,YAAA;EACA,WAAA;EACA,eAAA;EAEA,gBAAA;AAzBR;AA8BK;EACC,aAAA;EACA,mBAAA;AA5BN;;AAqCA;EACC,yBAAA;AAlCD;;AAqCA;EACC,2BAAA;AAlCD;;AAqCA;EACC,WAAA;AAlCD;;AAqCA;EACC,YAAA;AAlCD;;AAqCA;EACC,YAAA;AAlCD;;AAqCA;EACC,eAAA;AAlCD;;AAqCA;EACC,eAAA;AAlCD;;AAqCA;EACC,gBAAA;AAlCD;;AAqCA;EACC,gBAAA;AAlCD;;AAqCA;EACC,eAAA;AAlCD;;AAqCA;EACC,eAAA;AAlCD;;AAqCA;EACC,kBAAA;EACA,4BAAA;EACA,eAAA;AAlCD;;AAqCA;EACC,YAAA;EACA,+CAAA;EACA,mBAAA;AAlCD;;AAqCA;EACC,wDAAA;EACA,+CAAA;EACA,iBAAA;EACA,uCAAA;EACA,yBAAA;EACA,UAAA;AAlCD;;AAqCA;EACC,8BAAA;AAlCD;;AAqCA;EACC,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,wEAAA;AAlCD;;AAqCA;EAGC,wBAAA;AApCD;;AAuCA;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;AApCD;AAsCC;EACC,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uCAAA;EACA,gDAAA;EACA,eAAA;AApCF;AAsCE;EACC,gBAAA;AApCH;AAwCC;EACC,kBAAA;AAtCF;AAwCE;EACC,sCAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAtCH;;AA2CA;EACC,kBAAA;EACA,gBAAA;EACA,cAAA;AAxCD;;AA2CA;EACC,eAAA;AAxCD;;AA2CA;EACC,eAAA;AAxCD;;AA2CA;EACC,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,+BAAA;EACA,qBAAA;EACA,4BAAA;AAxCD;;AA2CA;EACC,aAAA;AAxCD;;AA4CA;EACC,kBAAA;AAzCD;;AA4CA;EACC,UAAA;EACA,aAAA;AAzCD;;AA4CA;EACC,YAAA;AAzCD;;AA4CA;EACC,uBAAA;AAzCD;;AA4CA;;EAEC,gBAAA;EACA,mBAAA;EACA,sCAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAzCD;;AA4CA;EACC,uDAAA;EACA,gBAAA;EACA,uCAAA;AAzCD;;AA4CA;EACC,YAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kDAAA;AAzCD;;AA8CC;;EACC,aAAA;AA1CF;;AA+CA;EACC,yBAAA;EACA,uCAAA;AA5CD;;AA+CA;EACC,qCAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AA5CD;;AA+CA;EACC,eAAA;AA5CD;;AA+CA;EACC,yBAAA;AA5CD;AA8CC;EACC,iCAAA;AA5CF","sourcesContent":["button {\n\tmargin-right: 0.5rem;\n}\n\n.div1 {\n\tpadding: 0.625rem;\n\ttext-align: center;\n\tborder-top: 1px solid lightgrey\n}\n\n.p-bold {\n\tfont-weight: bold;\n\tpadding: 0.3125rem 0;\n\tmargin: 0;\n}\n\n.p-normal {\n\tpadding: 0.3125rem 0;\n\tmargin: 0;\n}\n\n.mt-20 {\n\tmargin-top: 1.25rem;\n}\n\nion-button {\n\t--border-radius: 0;\n}\n\n.coupon-container {\n\t.coupon-top-section {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\twidth: 100%;\n\t\talign-items: center;\n\n\t\t.coupon-heading-class {\n\t\t\tfont-weight: 700;\n\t\t\tfont-size: 2.625rem;\n\t\t\tline-height: 100%;\n\t\t\tcolor: var(--ion-black-primary);\n\t\t\tpadding: 1.75rem 0 1.5625rem 0;\n\t\t}\n\t}\n}\n\n.coupon-field-div {\n\twidth: 49.2%;\n}\n\n.coupon-field {\n\tdisplay: flex;\n\tplace-content: space-between;\n\tmargin-bottom: 20px;\n}\n\n.back-btn {\n\twidth: 100px;\n\theight: 46px;\n\tbackground: #0081ca;\n\tfont: normal normal bold 15px/20px Noto Sans;\n\tletter-spacing: 0px;\n\tcolor: #FFFFFF;\n\ttext-transform: uppercase;\n}\n\n.back-btn-ltr {\n\tfloat: right;\n}\n\n.back-btn-rtl {\n\tfloat: left;\n}\n\n.add-discount-container {\n\t.listing-header {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding: 0.0625rem 0 1.875rem 0;\n\n\t\t.title-div {\n\t\t\tfont: normal normal bold 42px/42px Noto Sans;\n\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\ttext-transform: capitalize\n\t\t}\n\t}\n}\n\n.justify-end {\n\tjustify-content: flex-end;\n}\n\n.justify-start {\n\tjustify-content: flex-start;\n}\n\n.add-discount-container {\n\toverflow: auto;\n\tpadding: 1.5rem 1.875rem 1.5rem 1.875rem;\n\n\t.heading-label {\n\t\tfont: normal normal bold 1.125rem /27px Noto Sans;\n\t\tletter-spacing: 0;\n\t\tcolor: var(--ion-color-primary-black);\n\t\topacity: 1;\n\t}\n\n\t.form-container {\n\t\t.form-inputs {\n\t\t\tpadding-bottom: 0.75rem;\n\n\t\t\tion-item {\n\t\t\t\t.country-code {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tion-item.item-has-value,\n\t\t\tion-item.item-has-focus {\n\t\t\t\t.country-code {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tion-label {\n\t\t\t\tletter-spacing: 0 !important;\n\t\t\t\tcolor: var(--ion-color-secondary-black) !important;\n\t\t\t\ttext-transform: uppercase !important;\n\t\t\t\topacity: 1 !important;\n\t\t\t\tfont-size: 0.75rem !important;\n\t\t\t}\n\t\t}\n\t}\n}\n\nion-select {\n\twidth: 100%;\n\tfont: normal normal 600 1rem /24px Noto Sans;\n}\n\n.company-address-div {\n\twidth: 49.2%;\n}\n\n.company-address-class {\n\tdisplay: flex;\n\tplace-content: space-between;\n}\n\nion-input,\nion-item {\n\tletter-spacing: 0;\n\tcolor: var(--ion-color-primary-black);\n\topacity: 1;\n\tfont-size: 1rem;\n\tline-height: 1.3125rem;\n}\n\nion-list {\n\tpadding: 0;\n}\n\n.text-left {\n\tright: 0 !important;\n\tleft: unset !important;\n}\n\n.text-right {\n\tleft: 0 !important;\n\tright: unset !important;\n}\n\nion-select.LTR::part(icon) {\n\topacity: 1;\n\tcolor: transparent;\n\tmargin-left: 1rem;\n\tbackground: url('../../../assets/icon/down-arrow-dark.svg') no-repeat center;\n}\n\nion-select.RTL::part(icon) {\n\topacity: 1;\n\tcolor: transparent;\n\tmargin-right: 1rem;\n\tbackground: url('../../../assets/icon/down-arrow-dark.svg') no-repeat center;\n}\n\n.arabic-label {\n\tdirection: ltr !important;\n\ttext-align: right !important;\n}\n\n.arabic-select::part(placeholder) {\n\tdirection: ltr;\n\ttext-align: right;\n}\n\n.date-div {\n\talign-items: center;\n}\n\n.add-discount-div {\n\t.listing-header {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tpadding: 0.3125rem 0 1.5625rem 0;\n\n\t\t.title-div {\n\t\t\tfont: normal normal bold 1.75rem /28px Noto Sans;\n\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\ttext-transform: capitalize\n\t\t}\n\t}\n\n\t.listing-table {\n\t\tpadding: 0 0 1.25rem;\n\t\toverflow-x: auto;\n\n\t\t.table {\n\t\t\twidth: 100%;\n\n\t\t\t.column-heading {\n\t\t\t\tfont-weight: 500;\n\t\t\t\tfont-size: 0.975rem;\n\t\t\t\tline-height: 0.875rem;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tcolor: var(--ion-color-secondary-black);\n\t\t\t\tpadding: 0.75rem 0.5625rem 0.75rem 0;\n\t\t\t}\n\n\t\t\t.checkbox-col {\n\t\t\t\twidth: 40px;\n\t\t\t}\n\n\t\t\t.img-col {\n\t\t\t\twidth: 90px;\n\t\t\t}\n\n\t\t\t.ship-to-col {\n\t\t\t\tmin-width: 100px;\n\t\t\t\tmax-width: 244px;\n\t\t\t}\n\n\t\t\t.product-id {\n\t\t\t\tfont: normal normal bold 1rem /24px Noto Sans;\n\t\t\t\tletter-spacing: 0;\n\t\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\t\topacity: 1;\n\t\t\t}\n\n\t\t\t.table-body {\n\t\t\t\tfont: normal normal normal 1rem /21px Noto Sans;\n\t\t\t\tletter-spacing: 0;\n\t\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\t\topacity: 1;\n\n\t\t\t\t.table-row {\n\t\t\t\t\tborder-bottom: 1px solid var(--ion-color-primary-border);\n\n\t\t\t\t\ttd {\n\t\t\t\t\t\tpadding: 0.4375rem 0.5625rem 0.1875rem 0;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\t\tline-height: 1.375rem;\n\t\t\t\t\t\tcolor: var(--ion-color-primary-black);\n\n\t\t\t\t\t\t.product-image {\n\t\t\t\t\t\t\twidth: 5rem;\n\t\t\t\t\t\t\theight: 5rem;\n\t\t\t\t\t\t\tmax-width: 5rem;\n\t\t\t\t\t\t\tmax-height: 5rem;\n\n\t\t\t\t\t\t\timg {\n\t\t\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\t\tmax-width: 100%;\n\t\t\t\t\t\t\t\t;\n\t\t\t\t\t\t\t\tmax-height: 100%;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.right-arrow {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t}\n\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.justify-end {\n\tjustify-content: flex-end;\n}\n\n.justify-start {\n\tjustify-content: flex-start;\n}\n\n.id-col {\n\twidth: 60px;\n}\n\n.name-col {\n\twidth: 135px;\n}\n\n.subclass-col {\n\twidth: 100px;\n}\n\n.qty-sold-col {\n\tmin-width: 80px;\n}\n\n.price-col {\n\tmin-width: 60px;\n}\n\n.sku-col {\n\tmin-width: 100px;\n}\n\n.uploaded-time-col {\n\tmin-width: 120px;\n}\n\n.edit-col {\n\tmin-width: 60px;\n}\n\n.edit-img-icon {\n\tcursor: pointer;\n}\n\n.search-icon {\n\talign-self: center;\n\tmargin: 0.25rem 2.625rem 0 0;\n\tcursor: pointer;\n}\n\n.product-checkbox {\n\t--opacity: 1;\n\t--border-color: var(--ion-color-primary-border);\n\t--border-width: 1px;\n}\n\n.thead {\n\tborder-bottom: 1px solid var(--ion-color-primary-border);\n\tfont: normal normal bold 0.75rem /14px Noto Sans;\n\tletter-spacing: 0;\n\tcolor: var(--ion-color-secondary-black);\n\ttext-transform: uppercase;\n\topacity: 1;\n}\n\nth {\n\tpadding: 0.9375rem 0 1.25rem 0;\n}\n\nion-select::part(icon) {\n\topacity: 1;\n\tmargin-left: 1rem;\n\tcolor: transparent;\n\tbackground: url('../../../assets/icon/down-arrow-dark.svg') no-repeat center;\n}\n\n.add-discount-div {\n\t// overflow: auto;\n\t// max-height: 70%;\n\tpadding: 0 0.3125rem 0 0;\n}\n\n.profile-bottom-container {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\n\t.cancel {\n\t\tfont-weight: 400;\n\t\tfont-size: 0.9375rem;\n\t\tline-height: 1.125rem;\n\t\tletter-spacing: 0.4px;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--ion-color-secondary-black);\n\t\tpadding: 0.8125rem 2.1875rem 0.8125rem 2.1875rem;\n\t\tcursor: pointer;\n\n\t\t&:hover {\n\t\t\tfont-weight: 600;\n\t\t}\n\t}\n\n\t.profile-button {\n\t\tposition: relative;\n\n\t\tion-button {\n\t\t\t--background: var(--ion-color-primary);\n\t\t\twidth: 130px;\n\t\t\theight: 46px;\n\t\t\tfont-weight: 600;\n\t\t\tfont-size: 0.9375rem;\n\t\t\tline-height: 1.125rem;\n\t\t\tletter-spacing: 0.4px;\n\t\t\t--box-shadow: none;\n\t\t\t--border-radius: 0;\n\t\t}\n\t}\n}\n\n.close-div {\n\tposition: absolute;\n\tright: 0.3125rem;\n\ttop: 0.3125rem;\n}\n\n::-webkit-scrollbar {\n\twidth: 0.625rem;\n}\n\n.close-icon {\n\tcursor: pointer;\n}\n\np.file-name {\n\tmargin: 0;\n\tmargin-top: 0.5rem;\n\tfont-weight: 500;\n\twidth: 100%;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tdisplay: -webkit-box !important;\n\t-webkit-line-clamp: 1;\n\t-webkit-box-orient: vertical;\n}\n\n.country-code {\n\tdisplay: none;\n\n}\n\n.hidden-input {\n\tvisibility: hidden;\n}\n\n.file-input {\n\topacity: 0;\n\tdisplay: none;\n}\n\nion-item {\n\theight: 50px;\n}\n\nng-select {\n\theight: 50px !important;\n}\n\n.upload-btn,\n.remove-btn {\n\tmargin-top: auto;\n\tmargin-bottom: auto;\n\t--background: var(--ion-color-primary);\n\tfont-weight: 600;\n\tfont-size: 0.9375rem;\n\tline-height: 1.125rem;\n\tletter-spacing: 0.4px;\n\theight: 38px;\n\twidth: 90px;\n\t--border-radius: 0;\n\t--box-shadow: none;\n}\n\nremove-btn {\n\t--background: var(--ion-color-primary-white) !important;\n\tbox-shadow: none;\n\tcolor: var(--ion-color-secondary-black);\n}\n\n.preview-image {\n\theight: 100%;\n\twidth: 100%;\n\tmax-width: 116px;\n\tmax-height: 49px;\n\tobject-fit: contain;\n\tmargin: 0.3125rem 0.9375rem 0.3125rem 0 !important;\n}\n\nion-item.item-has-value,\nion-item.item-has-focus {\n\t.country-code {\n\t\tdisplay: flex;\n\n\t}\n}\n\nion-label {\n\ttext-transform: uppercase;\n\tcolor: var(--ion-color-secondary-black);\n}\n\n.spinner-btn {\n\tcolor: var(--ion-color-primary-white);\n\tposition: absolute;\n\tright: 81px;\n\ttop: 0.625rem;\n}\n\n.trash-icon {\n\tcursor: pointer;\n}\n\n.arabic-class {\n\tdirection: rtl !important;\n\n\tion-label {\n\t\t-webkit-transform-origin-x: right;\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
